<template>
<div class="responsive_tabs_agileits"> 
	<h3 class="wthree_text_info dir">نظرات</h3>
	<div class="single_page_agile_its_w3ls">
		<div class="bootstrap-tab-text-grid">
<!--
<div id="myCarousel" class="carousel slide" data-bs-ride="carousel" v-if="count !=0 ">
    <div class="carousel-inner">
        <div class="carousel-item " :class="item.active" v-for="item in list" :key="item.id" style="background: none;">
            <div style="text-align: center;font-size: 24px;">{{item.user}}</div>
            <small style="text-align: center;margin-top: 5px;color: #8b8988" class="d-block">{{item.time}}</small>
            <small style="text-align: center;margin-top: 5px;" class="d-block" >
                <i v-if="1 <= item.star" class="fa fa-star mr-1 " style="color: rgb(231, 231, 50);" ></i>
                <i v-if="2 <= item.star" class="fa fa-star mr-1 " style="color: rgb(231, 231, 50);" ></i>
                <i v-if="3 <= item.star" class="fa fa-star mr-1 " style="color: rgb(231, 231, 50);" ></i>
                <i v-if="4 <= item.star" class="fa fa-star mr-1 " style="color: rgb(231, 231, 50);" ></i>
                <i v-if="5 <= item.star" class="fa fa-star mr-1 " style="color: rgb(231, 231, 50);" ></i>
            </small>

            <div class="bootstrap-tab-text-grid-right">
                <p class="dir-rtl" style=" width: 80%;text-align: center;margin-right: auto;margin-left: auto;">
                    {{item.vote}}
                </p>
            </div>
        </div>
    </div>

     <button class="carousel-control-prev text-secondary" type="button" data-bs-target="#myCarousel" data-bs-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    </button>
    <button class="carousel-control-next " type="button" data-bs-target="#myCarousel" data-bs-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>

        <span class="visually-hidden">Next</span>
    </button>
</div> 
-->
			<div class="sc-b2b7a2ac-2 dcVdUe" v-if="count !=0 ">
			<div class="sc-6001711b-0 bztXvJ">
				<div class="sc-6001711b-1 lcHuNb">
				<div class="sc-6001711b-2 idMpUg">
					<div class="InlineChildren__StyledInlineChildren-sc-6r2tfo-0 dZNIAH">
					<h2 display="block" class="styles__TextElement-sc-3qedjx-0 fnIfiZ">دیگران راجع به این فروشگاه چه میگویند</h2>
					</div>
					<div class="StackChildren__StyledStackChildren-sc-5x3aej-0 fNxhMJ">
					<div></div>
					<div class="StackChildren__StyledStackChildren-sc-5x3aej-0 gJoNDK">
						<div class="InlineChildren__StyledInlineChildren-sc-6r2tfo-0 eDoSbG">
						<div class="InlineChildren__StyledInlineChildren-sc-6r2tfo-0 enKZat">
							<span display="block" color="#494949" class="styles__TextElement-sc-3qedjx-0 cwMzOx">میانگین امتیاز : </span>
							
							</div>
							<div class="InlineChildren__StyledInlineChildren-sc-6r2tfo-0 enKZat">
							<span display="block" class="styles__TextElement-sc-3qedjx-0 hsAHxt px-2">{{PersianNumber(avg.toFixed(1))}}</span>
						</div>
						</div>
					</div>
					</div>
				</div>
				</div>
				<div class="sc-6001711b-8 dOuBYZ">
				<div class="sc-6001711b-5 hlcfoc">
					<div data-telemetry-id="storeReviewCard" class="sc-b2b7a2ac-3 jiSGsb" v-for="item in list" :key="item.id" >
					<button class="sc-b2b7a2ac-0 fWLLAh">
						<div>
						<div class="StackChildren__StyledStackChildren-sc-5x3aej-0 gJoNDK">
							<div class="StackChildren__StyledStackChildren-sc-5x3aej-0 gJoNDG">
							<div class="InlineChildren__StyledInlineChildren-sc-6r2tfo-0 fpnchd">
								<div class="StackChildren__StyledStackChildren-sc-5x3aej-0 gJoNDQ">
								<div class="InlineChildren__StyledInlineChildren-sc-6r2tfo-0 fpnchd">
									<span display="block" class="styles__TextElement-sc-3qedjx-0 jdPVjd">{{item.user}}</span>
								</div>
								</div>
							</div>
							<div class="sc-5d57605f-3 ckgqVJ">
								<span display="block" color="SystemGrey60" class="styles__TextElement-sc-3qedjx-0 cbFhUJ ">{{item.time}}</span>

								<div class="InlineChildren__StyledInlineChildren-sc-6r2tfo-0 embond">
								<svg v-if="1 <= item.star" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" class="styles__StyledInlineSvg-sc-12l8vvi-0 djCUZq">
									<path d="M8.91126 0.588193C8.74945 0.230121 8.39293 0 7.99999 0C7.60705 0 7.25054 0.230121 7.08872 0.588193L5.37316 4.38448L1.23254 4.84295C0.841992 4.8862 0.512964 5.15416 0.39154 5.52786C0.270115 5.90157 0.378802 6.31175 0.669346 6.5763L3.7497 9.381L2.90621 13.4606C2.82665 13.8454 2.97982 14.2412 3.29771 14.4721C3.6156 14.7031 4.0393 14.7265 4.38068 14.5319L7.99999 12.469L11.6193 14.5319C11.9607 14.7265 12.3844 14.7031 12.7023 14.4721C13.0202 14.2412 13.1733 13.8454 13.0938 13.4606L12.2503 9.381L15.3306 6.5763C15.6212 6.31175 15.7299 5.90157 15.6084 5.52786C15.487 5.15416 15.158 4.8862 14.7674 4.84295L10.6268 4.38448L8.91126 0.588193Z" fill="#EEFF22"></path>
								</svg>
								<svg v-if="2 <= item.star" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" class="styles__StyledInlineSvg-sc-12l8vvi-0 djCUZq">
									<path d="M8.91126 0.588193C8.74945 0.230121 8.39293 0 7.99999 0C7.60705 0 7.25054 0.230121 7.08872 0.588193L5.37316 4.38448L1.23254 4.84295C0.841992 4.8862 0.512964 5.15416 0.39154 5.52786C0.270115 5.90157 0.378802 6.31175 0.669346 6.5763L3.7497 9.381L2.90621 13.4606C2.82665 13.8454 2.97982 14.2412 3.29771 14.4721C3.6156 14.7031 4.0393 14.7265 4.38068 14.5319L7.99999 12.469L11.6193 14.5319C11.9607 14.7265 12.3844 14.7031 12.7023 14.4721C13.0202 14.2412 13.1733 13.8454 13.0938 13.4606L12.2503 9.381L15.3306 6.5763C15.6212 6.31175 15.7299 5.90157 15.6084 5.52786C15.487 5.15416 15.158 4.8862 14.7674 4.84295L10.6268 4.38448L8.91126 0.588193Z" fill="#EEFF22"></path>
								</svg>
								<svg v-if="3 <= item.star" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" class="styles__StyledInlineSvg-sc-12l8vvi-0 djCUZq">
									<path d="M8.91126 0.588193C8.74945 0.230121 8.39293 0 7.99999 0C7.60705 0 7.25054 0.230121 7.08872 0.588193L5.37316 4.38448L1.23254 4.84295C0.841992 4.8862 0.512964 5.15416 0.39154 5.52786C0.270115 5.90157 0.378802 6.31175 0.669346 6.5763L3.7497 9.381L2.90621 13.4606C2.82665 13.8454 2.97982 14.2412 3.29771 14.4721C3.6156 14.7031 4.0393 14.7265 4.38068 14.5319L7.99999 12.469L11.6193 14.5319C11.9607 14.7265 12.3844 14.7031 12.7023 14.4721C13.0202 14.2412 13.1733 13.8454 13.0938 13.4606L12.2503 9.381L15.3306 6.5763C15.6212 6.31175 15.7299 5.90157 15.6084 5.52786C15.487 5.15416 15.158 4.8862 14.7674 4.84295L10.6268 4.38448L8.91126 0.588193Z" fill="#EEFF22"></path>
								</svg>
								<svg v-if="4 <= item.star" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" class="styles__StyledInlineSvg-sc-12l8vvi-0 djCUZq">
									<path d="M8.91126 0.588193C8.74945 0.230121 8.39293 0 7.99999 0C7.60705 0 7.25054 0.230121 7.08872 0.588193L5.37316 4.38448L1.23254 4.84295C0.841992 4.8862 0.512964 5.15416 0.39154 5.52786C0.270115 5.90157 0.378802 6.31175 0.669346 6.5763L3.7497 9.381L2.90621 13.4606C2.82665 13.8454 2.97982 14.2412 3.29771 14.4721C3.6156 14.7031 4.0393 14.7265 4.38068 14.5319L7.99999 12.469L11.6193 14.5319C11.9607 14.7265 12.3844 14.7031 12.7023 14.4721C13.0202 14.2412 13.1733 13.8454 13.0938 13.4606L12.2503 9.381L15.3306 6.5763C15.6212 6.31175 15.7299 5.90157 15.6084 5.52786C15.487 5.15416 15.158 4.8862 14.7674 4.84295L10.6268 4.38448L8.91126 0.588193Z" fill="#EEFF22"></path>
								</svg>
								<svg v-if="5 <= item.star" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" class="styles__StyledInlineSvg-sc-12l8vvi-0 djCUZq">
									<path d="M8.91126 0.588193C8.74945 0.230121 8.39293 0 7.99999 0C7.60705 0 7.25054 0.230121 7.08872 0.588193L5.37316 4.38448L1.23254 4.84295C0.841992 4.8862 0.512964 5.15416 0.39154 5.52786C0.270115 5.90157 0.378802 6.31175 0.669346 6.5763L3.7497 9.381L2.90621 13.4606C2.82665 13.8454 2.97982 14.2412 3.29771 14.4721C3.6156 14.7031 4.0393 14.7265 4.38068 14.5319L7.99999 12.469L11.6193 14.5319C11.9607 14.7265 12.3844 14.7031 12.7023 14.4721C13.0202 14.2412 13.1733 13.8454 13.0938 13.4606L12.2503 9.381L15.3306 6.5763C15.6212 6.31175 15.7299 5.90157 15.6084 5.52786C15.487 5.15416 15.158 4.8862 14.7674 4.84295L10.6268 4.38448L8.91126 0.588193Z" fill="#EEFF22"></path>
								</svg>
								
								</div>
							</div>
							</div>
							<span display="block" class="styles__TextElement-sc-3qedjx-0 lcTVNM sc-b2b7a2ac-5 eqicQd">
							<span display="block" class="styles__TextElement-sc-3qedjx-0 lcTVNM sc-f0e02c3b-2 ggXGbS" style="text-align: right;">{{item.vote}}</span>
							</span>
							<div class="InlineChildren__StyledInlineChildren-sc-6r2tfo-0 eJRtEB">
							<span overflow="normal" display="block" class="styles__TextElement-sc-3qedjx-0 hEGpgc sc-b2b7a2ac-6 fmJXop"></span>
							</div>
						</div>
						</div>
					</button>
					</div>
				</div>
				</div>
			</div>
			</div>
			<div v-else>هنوز برای این محصول نظری ثبت نشده است.</div>
		</div>
		<!-- <add-poll :user_id="userInfo[0].id" :addFlag="addFlag"></add-poll> -->
	</div>
</div>

</template>

<script setup>
import { ref,defineProps } from '@vue/reactivity'
import axios from 'axios'

let props = defineProps(['stuff_id']);
let list = ref()
let avg = ref(0)
let addFlag = ref(false)
let count = ref()
function getList(){
    axios
    .get('https://radap.ir/Backend/api/section/survay/list.php?stuff_id='+props.stuff_id)
    .then(res=>{
        addFlag.value = res.data.flag
        list.value = res.data.list
        count.value = res.data.count
		getAvg(list.value)
    })
}
getList()
function getAvg(list){
	for (let i = 0; i < list.length; i++) {
		avg.value += parseInt(list[i].star)
	}
	avg.value /= list.length
}
function PersianNumber(t){for(t=t.toString();t.search("0")>-1;)t=t.replace("0","۰");for(;t.search("1")>-1;)t=t.replace("1","۱");for(;t.search("2")>-1;)t=t.replace("2","۲");for(;t.search("3")>-1;)t=t.replace("3","۳");for(;t.search("4")>-1;)t=t.replace("4","۴");for(;t.search("5")>-1;)t=t.replace("5","۵");for(;t.search("6")>-1;)t=t.replace("6","۶");for(;t.search("7")>-1;)t=t.replace("7","۷");for(;t.search("8")>-1;)t=t.replace("8","۸");for(;t.search("9")>-1;)t=t.replace("9","۹");return t}

</script>

<style scoped>
.dcVdUe {
    width: 100%;
    max-width: 960px;
    margin: 20px auto;
}
.bztXvJ {
    position: relative;
    width: 100%;
}
.lcHuNb {
    display: flex;
    -webkit-box-pack: justify;
    justify-content: space-between;
}
.idMpUg {
    display: flex;
    flex-direction: column;
}
.dZNIAH {
    max-width: 100%;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    justify-content: space-between;
}
.fnIfiZ {
    font-size: 22px;
    font-family: 'Sahel';
    font-weight: 700;
    line-height: 30px;
    letter-spacing: -0.04ch;
    text-transform: none;
    color: rgb(25, 25, 25);
    margin: 0px;
    padding: 0px;
    display: block;
    font-variant-ligatures: no-common-ligatures;
}
.dsHpAb {
    right: 0px;
    position: absolute;
}
.dZNIAH > * + * {
    margin-left: 16px !important;
}
.bVqFxV {
    position: relative;
    max-width: 100%;
    margin: 0px;
    display: inline-flex;
    min-height: 32px;
    border-radius: 100%;
    border: none;
    cursor: pointer;
    transition: background-color 0.15s ease-in-out 0s, box-shadow 0.15s ease-in-out 0s;
    user-select: none;
    text-decoration: none;
    text-align: center;
    background-color: rgb(231, 231, 231);
    box-shadow: rgb(231 231 231) 0px 0px 0px 1px inset;
    color: rgb(25, 25, 25);
    height: 32px;
    width: 32px;
    padding: 0px;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
}
.jFpckg {
    flex-shrink: 0;
}
.fNxhMJ {
    max-width: 100%;
}
.gJoNDK {
    max-width: 100%;
}
<style>
.fNxhMJ > * + * {
    margin-top: 16px !important;
}
.eDoSbG {
    max-width: 100%;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: start;
    justify-content: flex-start;
}
.enKZat {
    max-width: 100%;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: start;
    justify-content: flex-start;
}
.hsAHxt {
    font-size: 18px;
    font-family: 'Sahel';
    font-weight: 700;
    line-height: 24px;
    letter-spacing: -0.04ch;
    text-transform: none;
    color: rgb(25, 25, 25);
    margin: 0px;
    padding: 0px;
    display: block;
    font-variant-ligatures: no-common-ligatures;
}
.FbIzD {
    transform: scale(1.5);
    transform-origin: center center;
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    flex-direction: column;
}
.eDoSbG > * + * {
    margin-left: 12px !important;
}
.enKZat {
    max-width: 100%;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: start;
    justify-content: flex-start;
}
.cwMzOx {
    font-size: 14px;
    font-family: 'Sahel';
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0ch;
    text-transform: none;
    color: rgb(73, 73, 73);
    margin: 0px;
    padding: 0px;
    display: block;
    font-variant-ligatures: no-common-ligatures;
}
.FbIzD {
    transform: scale(1.5);
    transform-origin: center center;
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    flex-direction: column;
}
.enKZat > * + * {
    margin-left: 4px !important;
}
.enKZat > * + * {
    margin-left: 4px !important;
}
.cwMzOx {
    font-size: 14px;
    font-family: 'Sahel';
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0ch;
    text-transform: none;
    color: rgb(73, 73, 73);
    margin: 0px;
    padding: 0px;
    display: block;
    font-variant-ligatures: no-common-ligatures;
}
.dOuBYZ {
    position: relative;
}
.hlcfoc {
    position: relative;
    display: flex;
    -webkit-box-align: start;
    align-items: start;
    flex-wrap: nowrap;
    overflow: auto hidden;
    width: 100%;
    padding: 16px 0px 0px;
}
.jiSGsb {
    text-align: left;
    border: none;
    width: 100%;
    display: flex;
    vertical-align: middle;
    margin-right: 16px;
    border-radius: 8px;
}
.fWLLAh {
    background: none;
    color: inherit;
    font: inherit;
    cursor: pointer;
    height: 154px;
    min-width: 212px;
    max-width: 212px;
    padding: 16px;
    border-radius: 8px;
    border: 1px solid rgb(227, 216, 216);
    display: inline-block;
    align-self: center;
    text-align: left;
    vertical-align: middle;
    margin: 0px;
}
.gJoNDK {
    max-width: 100%;
}
.gJoNDG {
    max-width: 100%;
}
.fpnchd {
    max-width: 100%;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: start;
    justify-content: flex-start;
}
.gJoNDQ {
    max-width: 100%;
}
.fpnchd {
    max-width: 100%;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: start;
    justify-content: flex-start;
}
.jdPVjd {
    font-size: 16px;
    font-family: 'Sahel';
    font-weight: 700;
    line-height: 22px;
    letter-spacing: -0.04ch;
    text-transform: none;
    color: rgb(25, 25, 25);
    margin: 0px;
    padding: 0px;
    display: block;
    font-variant-ligatures: no-common-ligatures;
}
.ckgqVJ {
    display: flex;
    flex-wrap: wrap;
    -webkit-box-align: center;
    align-items: center;
    gap: 4px;
	justify-content: space-between;
}
.gJoNDG > * + * {
    margin-top: 8px !important;
}
.embond {
    max-width: 100%;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: start;
    justify-content: flex-start;
}
.cbFhUJ {
    font-size: 14px;
    font-family: 'Sahel';
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0ch;
    text-transform: none;
    color: rgb(118, 118, 118);
    margin: 0px;
    padding: 0px;
    display: block;
    font-variant-ligatures: no-common-ligatures;
}
.enKZat {
    max-width: 100%;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: start;
    justify-content: flex-start;
}

.hlExXV {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
}
.cbFhUJ {
    font-size: 14px;
    font-family: 'Sahel';
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0ch;
    text-transform: none;
    color: rgb(118, 118, 118);
    margin: 0px;
    padding: 0px;
    display: block;
    font-variant-ligatures: no-common-ligatures;
}

.eqicQd {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    margin-top: 2px !important;
}
.gJoNDK > * + * {
    margin-top: 4px !important;
}
.lcTVNM {
    font-size: 16px;
    font-family: 'Sahel';
    font-weight: 500;
    line-height: 22px;
    letter-spacing: 0ch;
    text-transform: none;
    color: rgb(25, 25, 25);
    margin: 0px;
    padding: 0px;
    display: block;
    font-variant-ligatures: no-common-ligatures;
    height: 70px;
    text-align: right;
}
.ggXGbS {
    display: contents;
}

.eJRtEB {
    max-width: 100%;
    display: flex;
    -webkit-box-align: stretch;
    align-items: stretch;
    -webkit-box-pack: start;
    justify-content: flex-start;
}
.gJoNDK > * + * {
    margin-top: 4px !important;
}
.fmJXop {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.hEGpgc {
    font-size: 14px;
    font-family: 'Sahel';
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0ch;
    text-transform: none;
    color: rgb(118, 118, 118);
    text-align: left;
    margin: 0px;
    padding: 0px;
    display: block;
    font-variant-ligatures: no-common-ligatures;
}

</style>